/**
 * The OneLake address of a Fabric item, in Microsoft's GUID form (How do I connect to OneLake?):
 * "You must use GUIDs for both the workspace and the item, and don't need the item type."
 *   https://onelake.dfs.fabric.microsoft.com/<workspaceGUID>/<itemGUID>
 * Our workspace and item ids are those GUIDs (the Spec 185 key model), so no stored column is needed.
 */
const GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function oneLakeItemUrl(workspaceId?: string | null, itemId?: string | null): string | null {
  if (!workspaceId || !itemId || !GUID.test(workspaceId) || !GUID.test(itemId)) return null;
  return `https://onelake.dfs.fabric.microsoft.com/${workspaceId.toLowerCase()}/${itemId.toLowerCase()}`;
}
